<!--<h1 mat-dialog-title class="drilldown-title">User Picker</h1>
<button mat-raised-button color="red" (click)="applyChanges()" [mat-dialog-close]="true">Apply Changes</button>
<div mat-dialog-content>

<mat-grid-list cols="12" rowHeight="50px" [gutterSize]="'20px'" class="userGridListStyling">
  <mat-grid-tile *ngFor="let user of obs | async" class="userTileStyling" (click)="tileHighlight(user);"
                 [colspan]="4"
                 [rowspan]="4">
    <mat-icon class="userIconStyling">account_circle</mat-icon>
    <mat-grid-tile-footer class="userFooterStyling">
      {{user}}
    </mat-grid-tile-footer>
  </mat-grid-tile>
</mat-grid-list>

<mat-paginator [pageSizeOptions]="[3,6]"></mat-paginator>

</div>


<div *ngFor="let user of userTest">
  {{user}}
</div>-->

<div mat-dialog-content>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="telepoCdrs">

      <!--
  <!- Position Column ->
  <ng-container matColumnDef="callId">
    <th mat-header-cell *matHeaderCellDef> callId </th>
    <td mat-cell *matCellDef="let element"> {{element.callId}} </td>
  </ng-container>

  <!-- Name Column ->
  <ng-container matColumnDef="previousCallId">
    <th mat-header-cell *matHeaderCellDef> previousCallId </th>
    <td mat-cell *matCellDef="let element"> {{element.previousCallId}} </td>
  </ng-container>

  <!-- Weight Column ->
  <ng-container matColumnDef="initialCallId">
    <th mat-header-cell *matHeaderCellDef> initialCallId </th>
    <td mat-cell *matCellDef="let element"> {{element.initialCallId}} </td>
  </ng-container>

  <!-- Symbol Column ->
  <ng-container matColumnDef="startTime">
    <th mat-header-cell *matHeaderCellDef> startTime </th>
    <td mat-cell *matCellDef="let element"> {{element.startTime}} </td>
  </ng-container>


  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef> type </th>
    <td mat-cell *matCellDef="let element"> {{typeLookup[element.type]}} </td>
  </ng-container>


  <ng-container matColumnDef="result">
    <th mat-header-cell *matHeaderCellDef> result </th>
    <td mat-cell *matCellDef="let element"> {{resultLookup[element.result]}} </td>
  </ng-container>


  <ng-container matColumnDef="billingId">
    <th mat-header-cell *matHeaderCellDef> billingId </th>
    <td mat-cell *matCellDef="let element"> {{element.billingId | billingIdToOwnerType}} + {{element.billingId}} </td>
  </ng-container>


  <ng-container matColumnDef="sourcePhoneNumber">
    <th mat-header-cell *matHeaderCellDef> sourcePhoneNumber </th>
    <td mat-cell *matCellDef="let element"> {{element.sourcePhoneNumber}} </td>
  </ng-container>


  <ng-container matColumnDef="sourceUserId">
    <th mat-header-cell *matHeaderCellDef> sourceUserId </th>
    <td mat-cell *matCellDef="let element"> {{element.sourceUserId}} </td>
  </ng-container>


  <ng-container matColumnDef="targetPhoneNumber">
    <th mat-header-cell *matHeaderCellDef> targetPhoneNumber </th>
    <td mat-cell *matCellDef="let element"> {{element.targetPhoneNumber}} </td>
  </ng-container>


  <ng-container matColumnDef="targetUserId">
    <th mat-header-cell *matHeaderCellDef> targetUserId </th>
    <td mat-cell *matCellDef="let element"> {{element.targetUserId}} </td>
  </ng-container>


  <ng-container matColumnDef="duration">
    <th mat-header-cell *matHeaderCellDef> duration </th>
    <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
  </ng-container>

  <ng-container matColumnDef="transferredBy">
    <th mat-header-cell *matHeaderCellDef> transferredBy </th>
    <td mat-cell *matCellDef="let element"> {{element.transferredBy}} </td>
  </ng-container>

  <ng-container matColumnDef="sourceApType">
    <th mat-header-cell *matHeaderCellDef> sourceApType </th>
    <td mat-cell *matCellDef="let element"> {{element.sourceApType}} </td>
  </ng-container>

  <ng-container matColumnDef="targetApType">
    <th mat-header-cell *matHeaderCellDef> targetApType </th>
    <td mat-cell *matCellDef="let element"> {{element.targetApType}} </td>
  </ng-container>
    -->

      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
        <td mat-cell *matCellDef="let element" [ngSwitch]="column">

          <div *ngSwitchCase="'type'">{{element.type  | telepoCdrType}}</div>
          <div *ngSwitchCase="'billingId'">{{element.billingId | billingIdToOwnerType}} + {{element.billingId}}</div>
          <div *ngSwitchCase="'result'">{{element.result  | telepoCdrResult}}</div>
          <div *ngSwitchDefault>{{element[column]}}</div>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                   showFirstLastButtons
                   aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>



</div>




